import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Messages } from '@app/constants/constant';
import { map } from "rxjs/internal/operators/map";

@Injectable()
export class TechnologyAddEditService {
  
  constructor(private _httpClient: HttpClient
    ) {
  }

editTechnology(technology : any)
{
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let body = {
    name : technology.name,
    id : technology.id,
    loggedIn : JSON.parse(localStorage.getItem("currentUser")).user.id
  };
    return this._httpClient
      .post(`${environment.apiUrl}/${Messages.endpoint.editTechnology}`, body, { headers : headers }).pipe(map(res => {
        return res;
        }));
}

addTechnology(technology : any)
{
  let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  let body = {
    name : technology.name,
    loggedIn : JSON.parse(localStorage.getItem("currentUser")).user.id
  };
    return this._httpClient
      .post(`${environment.apiUrl}/${Messages.endpoint.addTechnology}`, body, { headers : headers }).pipe(map(res => {
        return res;
        }));
}

getAllTechnologies(params : any)
{
  let queryString = "";
   if (params)
   {
      queryString =  "?" + params.toQueryString();
   }
    return this._httpClient
      .get(`${environment.apiUrl}/technology/superadmin-technology${queryString}`).pipe(map((res : any) => {
          return res;
        }));
}

}